import { css } from 'styled-components'

import { helpers } from './theme'

export default css`
	*,
	*:after,
	*:before {
		box-sizing: border-box;
	}

	* {
		&::-moz-focus-inner {
			border: 0;
		}

		&:focus {
			outline: none;
		}
	}

	html {
		font-family: ${helpers.font.family.base};
		font-size: ${helpers.font.size.base};
		line-height: 1.428571429;
		color: ${helpers.color.text};
		-webkit-tap-highlight-color: rgba(0, 0, 0, 0);
	}

	body {
		background-color: ${helpers.color.background};
		-webkit-font-smoothing: auto;
	}

	button,
	input,
	select,
	textarea {
		font-family: inherit;
		font-size: inherit;
		line-height: inherit;
	}

	a {
		color: ${helpers.color.link};
		text-decoration: none;

		&:focus,
		&:hover {
			color: ${helpers.color.link};
			text-decoration: underline;
		}

		&:focus {
			outline: 5px auto -webkit-focus-ring-color;
			outline-offset: -2px;
		}
	}

	img {
		vertical-align: middle;
	}

	hr {
		margin: ${helpers.font.size.base} 0;
		border: 0;
		border-top: 2px solid ${helpers.color.separator};
	}
`
